
import React , {useState } from "react" ;
import { useSelector } from "react-redux";
import { nanoid } from '@reduxjs/toolkit';

import { addEltHistory , useContrats } from "../../state/reactquery";
import { queryClient } from '../../state/queryClient';

import { axios_files_addclientfile } from "../../axios/axios_files";
import { axios_contrats_updatecontrat } from "../../axios/axios_contrats";

import { modifyonelead } from "../../utils/actions_lead";

import './ContratWinFicContratUpload.scss' ; 
function ContratWinFicContratUploadTwoFiles(){

    const lead = useSelector(state=>state.lead.leadactu) ;

    const [loading1, setLoading1] = useState(false) ; 
    const [loading2, setLoading2] = useState(false) ; 

   const {data: contrats} = useContrats(lead?.email,lead?.courtier) ; 
   const contratprojet = contrats?.filter(c=>c.id_contrat===lead.id_contrat)?.[0] ;

    
    const senddocdejasigne= async (e) =>{ 

        const texthistory =e.target.id === 'uploadbulletin' ? 'Bulletin signé à l’extérieur  importé.':'Fiche Conseil signée à l’extérieur  importé.' ;
        const type_file = e.target.id === 'uploadbulletin' ?'signature':'conseil' ; 
        const nomfichier = e.target.id === 'uploadbulletin' ?`contrat${(nanoid(5)).toString()}`:`conseil${(nanoid(5)).toString()}`;
        
       
        const newlead = (e.target.id === 'uploadbulletin' && lead.sign_fic===2&& lead.sign_docs===2 )?{...lead,'sign_bulletin':2, 'statut_client':'gagne'}:
                        (e.target.id === 'uploadbulletin' && lead.sign_fic===2&& lead.sign_docs!==2 )?{...lead,'sign_bulletin':2, 'statut_client':'attente_documents'}:
                        (e.target.id === 'uploadbulletin' && lead.sign_fic!==2 )?{...lead,'sign_bulletin':2, 'statut_client':'attente_signature'}:
                        (e.target.id === 'uploadfic' && lead.sign_bulletin===2 && lead.sign_docs===2  )?{...lead,'sign_fic':2, 'statut_client':'gagne'}:
                        (e.target.id === 'uploadfic' && lead.sign_bulletin===2 && lead.sign_docs!==2  )?{...lead,'sign_fic':2, 'statut_client':'attente_documents'}:
                        {...lead,'sign_fic':2, 'statut_client':'attente_signature'};
    
        e.target.id === 'uploadbulletin' ? setLoading1(true) : setLoading2(true)  ; 
        const filecontrat = e.target.files[0] ; 
        const data = new FormData() ;
         // DEV IDCONTRAT   
        data.append('datajson', JSON.stringify({courtier:lead?.courtier,id_client:lead.id_client ,id_lead:lead.id ,type_file,commercial:lead?.commercial,nomfichier, id_contrat: lead.id_contrat }) )
        data.append('file',filecontrat,`/${nomfichier}.${e.target.files[0].name.split('.')[1]}`);
        const repaddclientfile = await  axios_files_addclientfile(data,()=>{return })  ;
        modifyonelead(newlead) ;   
        addEltHistory(lead.id,'documents',  `<div class='horoline1' >${texthistory}</div>`) ;

        const cond_bulletin = e.target.id === 'uploadbulletin' || lead.sign_bulletin===2 ;
        const cond_docs = lead.sign_docs===2 || (e.target.id === 'uploadfic' || lead.sign_fic===2) ;

        const new_etatcontrat = (cond_bulletin &&  cond_docs)?'encours':'attentedocuments';

                                   
        e.target.id === 'uploadbulletin' && await axios_contrats_updatecontrat({indexe:contratprojet.indexe,etat_contrat:new_etatcontrat,url:repaddclientfile.data.url,date_signature: new Date()}) ;

        setTimeout(()=>{document.getElementById('uploadfic') && (document.getElementById(e.target.id).value= null )  },1000); 
        queryClient.invalidateQueries({ queryKey: ['documents',lead?.id]}) ; 
        e.target.id === 'uploadbulletin' ? setLoading1(false) : setLoading2(false)  ; 
    }

    return( <div className='contratwin_box2'>
                <div className="contratwindevis_upload2">
                        <div className="contratwindevis_upload_texte"  >{loading2 ?<div className="loadingupload"></div> :'Fiche Conseil signée'}</div>
                        <input type='file' id='uploadfic' className="uploadvalidcontrat_input"
                                onChange={senddocdejasigne} />
                </div>
                <div className="contratwindevis_upload2">
                        <div className="contratwindevis_upload_texte"  >{loading1 ?<div className="loadingupload"></div> :'Bulletin signé'}</div>
                        <input type='file' id='uploadbulletin' className="uploadvalidcontrat_input"
                                onChange={senddocdejasigne} />
                </div>
            </div>);
}



export default ContratWinFicContratUploadTwoFiles ;



